export default __webpack_public_path__ + "static/media/vi_Comparsa.0f9cb3da.mp4";